export default "__VITE_ASSET__CWZV9psW__"